/* Inserisce una pastiglia .pill-new al posto del testo NEW
   Funziona sui SOLI link del menu con classe 'yv-dropdown-item-link'
   Non tocca i link che hanno già <span class="pill-new">NEW</span> */
(function () {
  // Selettori: desktop + mobile
  const LINK_SELECTOR = 'a.yv-dropdown-item-link, li.nav-item a';

  // Mappa etichette → classi CSS
  const TAGS = { NEW: 'pill-new', NEU: 'pill-neu', POPULAR: 'pill-new' };

  // Regex con "word boundary" unicode (no lettere/numeri attaccati)
  // Usa lookaround per gestire punteggiatura e NBSP
  const TAG_NAMES = Object.keys(TAGS).join('|'); // "NEW|NEU"
  const TAG_BOUNDARY = `(?<![\\p{L}\\p{N}])(${TAG_NAMES})(?![\\p{L}\\p{N}])`;
  const TAG_REGEX = new RegExp(TAG_BOUNDARY, 'gu');

  function processAll(root) {
    root.querySelectorAll(LINK_SELECTOR).forEach(processLink);
  }

  function processLink(a) {
    // Cammina in TUTTI i nodi di testo del link, ma NON dentro pastiglie già create
    const walker = document.createTreeWalker(
      a,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          // Salta testi vuoti o spazi
          if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          // Non toccare testi già dentro una pastiglia
          if (node.parentElement && node.parentElement.closest('.pill-new, .pill-neu')) {
            return NodeFilter.FILTER_REJECT;
          }
          // Verifica match senza alterare lastIndex
          return (new RegExp(TAG_REGEX.source, 'u')).test(node.nodeValue)
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        }
      },
      false
    );

    const targets = [];
    let n;
    while ((n = walker.nextNode())) targets.push(n);
    targets.forEach(replaceTagsInTextNode);
  }

  function replaceTagsInTextNode(textNode) {
    const text = textNode.nodeValue;
    // split mantenendo il token catturato
    const parts = text.split(new RegExp(`(${TAG_NAMES})`, 'gu'));

    // Se non c'è nulla da fare, esci
    if (parts.length === 1) return;

    const frag = document.createDocumentFragment();
    for (let i = 0; i < parts.length; i++) {
      const chunk = parts[i];
      if (!chunk) continue;

      // Se è un tag (NEW/NEU) e rispetta i boundary, crea la pastiglia
      if (TAGS[chunk]) {
        // Conferma boundary sul punto esatto (evita falsi positivi tipo "RENEW")
        // Costruiamo il contesto per essere sicuri dei bordi:
        const before = parts[i - 1]?.slice(-1) || '';
        const after = parts[i + 1]?.charAt(0) || '';
        const isBoundary =
          !/\p{L}|\p{N}/u.test(before) &&
          !/\p{L}|\p{N}/u.test(after);

        if (isBoundary) {
          const span = document.createElement('span');
          span.className = TAGS[chunk];
          span.textContent = chunk;
          frag.appendChild(span);
          continue;
        }
      }

      // Non è un tag o non rispetta i boundary: testo normale
      frag.appendChild(document.createTextNode(chunk));
    }

    textNode.parentNode.replaceChild(frag, textNode);
  }

  function runNow() { processAll(document); }

  if (document.readyState !== 'loading') runNow();
  else document.addEventListener('DOMContentLoaded', runNow);

  // Aggiorna anche per menu dinamici
  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      m.addedNodes && m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(LINK_SELECTOR)) processLink(node);
        else if (node.querySelectorAll) processAll(node);
      });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  console.log('[pill tags] attivo');
})();